import { render, staticRenderFns } from "./detail_pickup.vue?vue&type=template&id=07768818&scoped=true&"
import script from "./detail_pickup.vue?vue&type=script&lang=js&"
export * from "./detail_pickup.vue?vue&type=script&lang=js&"
import style0 from "./detail_pickup.vue?vue&type=style&index=0&id=07768818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07768818",
  null
  
)

export default component.exports